import script from "./record-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./record-list.vue?vue&type=script&lang=ts&setup=true"

import "./record-list.vue?vue&type=style&index=0&id=9b338f50&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b338f50"]])

export default __exports__